.notice {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2) var(--space-4);
  padding: var(--space-3) var(--space-4);
  border: 1px solid var(--status-error-fg);
  border-left-width: 4px;
  border-radius: var(--radius-control);
  background: var(--status-error-bg);
  color: var(--ink);
  font: var(--t-body);
}

.notice[data-tone='info'] {
  border-color: var(--status-info-fg);
  background: var(--status-info-bg);
}

.text {
  flex: 1 1 16rem;
  min-width: 0;
  max-width: 75ch;
}

.notice[data-tone='error'] .text {
  font: var(--t-body-strong);
}

.action {
  flex: none;
}
